module.exports = __webpack_public_path__ + "img/montana_noche.c5a816dd.jpg";